import React from "react";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-serif-display text-2xl mt-8 mb-3">{title}</h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-[hsl(90_4%_10%)]">{children}</div>
  </section>
);

export default function LegalPageShell({ eyebrow, title, updated, children }) {
  return (
    <div className="mx-auto max-w-3xl px-6 md:px-10 py-16" data-testid="legal-page">
      <p className="text-xs uppercase tracking-[0.25em] text-[hsl(10_51%_55%)]">{eyebrow}</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mt-3 leading-tight">{title}</h1>
      <p className="mt-3 text-sm text-[hsl(100_3%_30%)]">Last updated: {updated}</p>
      <div className="mt-10 prose prose-neutral max-w-none">{children}</div>
      <div className="mt-16 border-t border-[hsl(165_37%_17%/0.1)] pt-8 text-sm text-[hsl(100_3%_30%)]">
        <p>Questions? Reach us at <a href="mailto:newdaystay@gmail.com" className="text-[hsl(10_51%_55%)] font-medium">newdaystay@gmail.com</a> or on WhatsApp at <a href="https://wa.me/916360734483" className="text-[hsl(10_51%_55%)] font-medium">+91 63607 34483</a>.</p>
      </div>
    </div>
  );
}

export { Section };
